type TypeIsNumberKeyConfig = {
    preventDefault?: boolean;
};

// ----------------------------------------------------------------------------

function isNumberKey(event: KeyboardEvent, config: TypeIsNumberKeyConfig = {}): boolean {
    const allowedKeys = ['Backspace', 'Tab', 'Enter', 'Home', 'End', 'Delete'];

    if (/^\d$/.test(event.key)) {
        return true;
    }

    if (allowedKeys.includes(event.key)) {
        return true;
    }

    if (config.preventDefault === true) {
        event.preventDefault();
    }

    return false;
}

// ----------------------------------------------------------------------------

export default isNumberKey;
